/**
 * ============================================================================
 * PAYMENT SERVICE - API CLIENT
 * ============================================================================
 * 
 * Handles all payment-related API calls
 */

import api, { handleApiError } from './api';

/**
 * Initiate payment
 */
export const initiatePayment = async (data) => {
  try {
    const response = await api.post('/payments/initiate', data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get payment by ID
 */
export const getPayment = async (paymentId) => {
  try {
    const response = await api.get(`/payments/${paymentId}`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Verify payment
 */
export const verifyPayment = async (paymentId, data) => {
  try {
    const response = await api.post(`/payments/${paymentId}/verify`, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get payment status
 */
export const getPaymentStatus = async (paymentId) => {
  try {
    const response = await api.get(`/payments/${paymentId}/status`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Cancel payment
 */
export const cancelPayment = async (paymentId) => {
  try {
    const response = await api.post(`/payments/${paymentId}/cancel`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Refund payment
 */
export const refundPayment = async (paymentId, data) => {
  try {
    const response = await api.post(`/payments/${paymentId}/refund`, data);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * List payments
 */
export const listPayments = async (filters = {}) => {
  try {
    const response = await api.get('/payments', {
      params: filters,
    });
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get payment statistics
 */
export const getPaymentStats = async () => {
  try {
    const response = await api.get('/payments/stats');
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get payment methods
 */
export const getPaymentMethods = async () => {
  try {
    const response = await api.get('/payments/methods');
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Get payment history
 */
export const getPaymentHistory = async (filters = {}) => {
  try {
    const response = await api.get('/payments/history', {
      params: filters,
    });
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Retry payment
 */
export const retryPayment = async (paymentId) => {
  try {
    const response = await api.post(`/payments/${paymentId}/retry`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export default {
  initiatePayment,
  getPayment,
  verifyPayment,
  getPaymentStatus,
  cancelPayment,
  refundPayment,
  listPayments,
  getPaymentStats,
  getPaymentMethods,
  getPaymentHistory,
  retryPayment,
};
